import activityEffectReport from './activityEffectReport'
export default activityEffectReport
